import moment from "moment"
import { COUNTRY, CURRENCY } from "../constants/app"
import { ICartData } from "../store/giftshop/type"

const formatPayload = (data: any, type: string) => {
    switch (type) {
        case 'view_item':
            return {
                event: "autoEvent",
                event_category: "Film Interactions",
                event_action: "Film Page View",
                event_label: "view_item",
                logged_user: data.isLoggedIn,
                film_name: data?.films?.movieName,
                cms_id: data.films?.movieGroupId,
                genre: `[]`,
                venue_name: data.films?.cinemaName,
                ecommerce: {
                    items: [{
                        item_name: data?.films?.movieName,
                        item_id: data?.films?.movieId,
                        item_category: data?.films?.cinemaName,
                    }]
                }
            }
        case 'select_item':
            return {
                event: "autoEvent",
                event_category: "Showtime Interactions",
                event_action: "Showtime Click",
                event_label: "select_item",
                logged_user: data.isLoggedIn,
                film_name: data?.films?.movieName,
                cms_id: data.films?.movieGroupId,
                genre: `[]`,
                venue_name: data.films?.cinemaName,
                show_date: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                show_time: moment.parseZone(data?.films?.showDateTime).format("HH:mm"),
                ecommerce: {
                    items: [{
                        item_name: data?.films?.movieName,
                        item_id: data?.films?.movieId,
                        item_category: data?.films?.cinemaName,
                        item_category2: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                        item_variant: "Ticket",
                    }]
                }
            }
        case 'add_to_cart':
            return {
                event: "autoEvent",
                event_category: "Ticket Checkout",
                event_action: "Add to Cart",
                event_label: "add_to_cart",
                logged_user: data.isLoggedIn,
                film_name: data?.films?.movieName,
                cms_id: data.films?.movieGroupId,
                genre: `[]`,
                venue_name: data.films?.cinemaName,
                show_date: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                show_time: moment.parseZone(data?.films?.showDateTime).format("HH:mm"),
                ecommerce: {
                    items: [{
                        item_name: data?.films?.movieName,
                        item_id: data?.films?.movieId,
                        item_category: data?.films?.cinemaName,
                        item_category2: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                        item_variant: "Ticket",
                    }]
                }
            }
        case 'begin_checkout':
            return {
                event: "autoEvent",
                event_category: "Ticket Checkout",
                event_action: "Start Checkout",
                event_label: "begin_checkout",
                logged_user: data.isLoggedIn,
                film_name: data?.films?.movieName,
                cms_id: data.films?.movieGroupId,
                genre: `[]`,
                venue_name: data.films?.cinemaName,
                show_date: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                show_time: moment.parseZone(data?.films?.showDateTime).format("HH:mm"),
                ecommerce: {
                    items: [{
                        item_name: data?.films?.movieName,
                        item_id: data?.films?.movieId,
                        item_category: data?.films?.cinemaName,
                        item_category2: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                        item_variant: "Ticket",
                    }]
                }
            }
        case 'purchase':
            return {
                event: "autoEvent",
                event_category: "Ticket Checkout",
                event_action: "Ticket Purchase",
                event_label: "purchase",
                logged_user: data.isLoggedIn,
                film_name: data?.films?.movieName,
                cms_id: data.films?.movieGroupId,
                genre: `[]`,
                venue_name: data.films?.cinemaName,
                show_date: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                show_time: moment.parseZone(data?.films?.showDateTime).format("HH:mm"),
                ecommerce: {
                    transaction_id: data?.ticketDetails?.userSessionId,
                    value: data?.total,
                    currency: CURRENCY[data.countryId as COUNTRY],
                    items: data?.ticketDetails?.ticketTypes?.map((v: any) =>
                    ({
                        item_name: data?.films?.movieName,
                        item_id: data?.films?.movieId,
                        item_category: data?.films?.cinemaName,
                        item_category2: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                        item_variant: "Ticket",
                        show_date: moment.parseZone(data?.films?.showDateTime).format("DD-MM-YYYY"),
                        price: (v.total).toFixed(2),
                        quantity: v.qty,
                    }))
                }
            }
        case 'gift_card_page_view':
            return {
                event: "autoEvent",
                event_category: "Gift Card funnel",
                event_action: "Gift Card page view",
                event_label: "page_view",
                logged_user: data?.isLoggedIn,
                gift_card_type: [(data?.giftType?.toLowerCase()).includes('physical') ? 'Physical' : (data?.giftType?.toLowerCase()).includes('experiences')?'Experiences': 'E-Gift'],
                ecommerce: {
                    items: data?.cards?.map((v: any) => ({
                        item_name: v?.name,
                        item_id: v?.id,
                        item_variant: 'Gift Card'
                    }))
                }
            }
        case 'gift_card_add_to_cart':
            return {
                event: "autoEvent",
                event_category: "Gift Card funnel",
                event_action: "Gift Card Add to Cart",
                event_label: "add_to_cart",
                logged_user: data?.isLoggedIn,
                gift_card_type: [(data?.giftType?.toLowerCase()).includes('physical') ? 'Physical' : (data?.giftType?.toLowerCase()).includes('experiences')?'Experiences': 'E-Gift'],
                ecommerce: {
                    items: [{
                        item_name: data?.card?.description,
                        item_id: data?.card?.id,
                        item_variant: 'Gift Card',
                        price: data?.card?.isVariablePriceItem?(data?.card?.giftamount?.toFixed(2)):(data?.card?.price?.toFixed(2)),
                        quantity: data?.card?.quantity
                    }]
                }
            }
        case 'gift_card_begin_checkout':
            const giftcardTypeBegin = [...new Set(data?.cart?.map((v:any)=>{
                return v?.giftcardType === 1?'E-Gift':v?.giftcardType === 2?'Physical':'Experiences'
            }))]
            return {
                event: "autoEvent",
                event_category: "Gift Card funnel",
                event_action: "Gift Card Checkout",
                event_label: "begin_checkout",
                logged_user: data?.isLoggedIn,
                gift_card_type: giftcardTypeBegin,
                ecommerce: {
                    items: data?.cart?.map((values: ICartData) => ({
                        item_name: (values?.promo?.name) ? (values?.promo?.name) : (values?.description),
                        item_id: (values?.promo?.name) ? (values?.promo?.id) : (values?.id),
                        item_variant: (values?.promo?.name) ? 'Promo Card' : 'Gift Card',
                        price: (values?.promo?.name) ? (values?.promo?.amount?.toFixed(2)) : (values?.isVariablePriceItem?(values.giftamount?.toFixed(2)):(values?.price?.toFixed(2))),
                        quantity: (values?.promo?.name) ? 1 : values.quantity
                    }))
                }
            }
        case 'gift_card_purchase':
            const giftcardTypePurchase = [...new Set(data?.cart?.map((v:any)=>{
                return v?.giftcardType === 1?'E-Gift':v?.giftcardType === 2?'Physical':'Experiences'
            }))]
            return {
                event: "autoEvent",
                event_category: "Gift Card funnel",
                event_action: "Gift Card Purchase",
                event_label: "purchase",
                logged_user: data?.isLoggedIn,
                gift_card_type: giftcardTypePurchase,
                ecommerce: {
                    transaction_id: data?.bookingId,
                    value: data?.total?.toFixed(2),
                    currency: data?.currency,
                    items: data?.cart?.map((values: ICartData) => ({
                        item_name: (values?.promo?.name) ? (values?.promo?.name) : (values?.description),
                        item_id: (values?.promo?.name) ? (values?.promo?.id) : (values?.id),
                        item_variant: (values?.promo?.name) ? 'Promo Card' : 'Gift Card',
                        price: (values?.promo?.name) ? (values?.promo?.amount?.toFixed(2)) : (values?.isVariablePriceItem?(values.giftamount?.toFixed(2)):(values?.price?.toFixed(2))),
                        quantity: (values?.promo?.name) ? 1 : values.quantity
                    }))
                }
            }
    
        default:
            return null;
    }
}

export const pushDataLayer = (data: any, type: string) => {
    try {
        const payload = formatPayload(data, type);
        if (window && payload) {
            const dataLayer = (window as any).dataLayer
            if (dataLayer) {
                dataLayer.push(payload);
                console.log('datalayer', payload)
            }
        }
        return;
    } catch (err) {
        return;
    }
}